import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BcService } from 'src/app/shared/services/bc/bc.service';
import { BpService } from 'src/app/shared/services/bp/bp.service';
import { NTHFlag } from 'src/app/shared/constants/flag';
import { GlobalSettingsService } from 'src/app/core/gobal-settings.service';
import { environment } from 'src/environments/environment';

export interface DialogData {
  icone: string;
  title: string;
  message: string;
  color: string;
  icon_color: string;
  dialogWidth: string;
  dialogHeight: string;
  result: boolean;
}
@Component({
  selector: 'app-modal-envoye-relance',
  templateUrl: './modal-envoye-relance.component.html',
  styleUrls: ['./modal-envoye-relance.component.scss']
})

export class ModalEnvoyeRelance implements OnInit {
  icone: string;
  title: string;
  message: string;
  color: string;
  iconColor: string;
  dialogWidth: string;
  dialogHeight: string;

  constructor(public dialog: MatDialog,
              public router: Router,
              public dialogRef: MatDialogRef<Component>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }

  ngOnInit(): void {
    this.icone = this.data.icone !== undefined ? this.data.icone : '';
    this.title = this.data.title !== undefined ? this.data.title : '';
    this.iconColor = this.data.icon_color !== undefined ? this.data.icon_color : '';
    this.dialogWidth = this.data.dialogWidth !== undefined ? this.data.dialogWidth : '';
    this.dialogHeight = this.data.dialogHeight !== undefined ? this.data.dialogHeight : '';
    this.message = this.data.message;
    this.color = this.data.color;
  }

  onModalCancel(): void {
    this.dialogRef.close(false);
  }

  onModalConfirm(action): void {
    this.data.result = true;
    this.dialogRef.close(action);
  }
}